import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';

const PagePrivacy = () => {
  return (
    <React.Fragment>
      <section className="section">
        <section className="d-table w-100" style={{ paddingBottom: 60 }}>
          <Container>
            <Row className="mt-5 justify-content-center">
              <Col lg={12} className="text-center">
                <div className="pages-heading">
                  <h4 className="title mb-0"> Our Privacy Policy </h4>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <Container>
          <Row className="justify-content-center">
            <Col lg={9}>
              <Card className="shadow border-0 rounded">
                <CardBody>
                  <h5 className="card-title">Last updated: October 24, 2026</h5>
                  <p className="text-muted">
                    This Privacy Policy explains what information HighVocab ("we", "us", "our") collects
                    when you use any HighVocab product, how we use it, and the choices you have. It covers:
                  </p>
                  <ul className="text-muted">
                    <li>the website at highvocab.com,</li>
                    <li>the HighVocab browser extension for Chrome, Edge and Firefox, and</li>
                    <li>the HighVocab app for iPhone and Android.</li>
                  </ul>

                  <h5 className="card-title">1. Information we collect</h5>
                  <p className="text-muted">
                    <b>Account information.</b> When you sign up we collect your name, email address and
                    password. Your password is stored only as a secure hash; we never store it in plain text.
                  </p>
                  <p className="text-muted">
                    <b>Your learning data.</b> The words and phrases you save, your word packs, your
                    translation language and other settings, which words you mark as memorized, and your
                    quiz and review results. We store this on our servers so your list stays in sync
                    between the website, the extension and the app.
                  </p>
                  <p className="text-muted">
                    <b>Text you send to AI features.</b> When you use AI Writing Help, the text you enter is
                    sent to our servers and processed by a third-party AI service to generate a response. It
                    is used only to answer your request.
                  </p>
                  <p className="text-muted">
                    <b>Purchase information.</b> If you buy a subscription, payment is handled by our
                    payment processor on the website, and by Apple or Google in the mobile app. We receive your subscription status and purchase records. We never receive or store your
                    full card number.
                  </p>
                  <p className="text-muted">
                    <b>Notifications.</b> If you allow notifications in the mobile app, we store a device
                    push token so we can send you daily reminders. You can turn this off at any time in your
                    device settings.
                  </p>
                  <p className="text-muted">
                    <b>Website analytics.</b> The highvocab.com website uses Google Analytics to understand
                    how visitors use the site. It uses cookies and similar technologies and may collect
                    information such as your IP address, browser type and pages visited. You can opt out at{' '}
                    <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noreferrer">
                      tools.google.com/dlpage/gaoptout
                    </a>
                    .
                  </p>

                  <h5 className="card-title">2. What the browser extension does with web pages</h5>
                  <p className="text-muted">
                    To highlight your saved words, the extension reads the text of the pages you visit,
                    including YouTube and Netflix subtitles. This happens on your computer. We do{' '}
                    <b>not</b> collect or store your browsing history or the contents of the pages you
                    visit. Information is sent to our servers only when you act on it, for example when you
                    look up or save a word or phrase.
                  </p>

                  <h5 className="card-title">3. How we use your information</h5>
                  <ul className="text-muted">
                    <li>To create and secure your account and sign you in.</li>
                    <li>To provide the service: store and sync your words, show translations, run quizzes and generate AI responses.</li>
                    <li>To process subscriptions and provide customer support.</li>
                    <li>To send reminders you have turned on, and important service emails such as password resets.</li>
                    <li>To understand how the website is used.</li>
                  </ul>
                  <p className="text-muted">We do not sell your personal information.</p>

                  <h5 className="card-title">4. Who we share it with</h5>
                  <p className="text-muted">
                    We share information only with service providers that help us run HighVocab, and only
                    as needed for them to do so:
                  </p>
                  <ul className="text-muted">
                    <li>hosting and data storage,</li>
                    <li>AI processing for AI Writing Help,</li>
                    <li>payment processing (including Apple and Google for in-app purchases), and</li>
                    <li>website analytics (Google Analytics).</li>
                  </ul>
                  <p className="text-muted">
                    These providers may use your information only to provide their services to us.
                  </p>
                  <p className="text-muted">
                    We may also disclose information if required by law or to protect the rights and safety
                    of our users or others.
                  </p>

                  <h5 className="card-title">5. Keeping and deleting your data</h5>
                  <p className="text-muted">
                    We keep your account and learning data for as long as your account is active. You can
                    delete individual words and phrases at any time in the app or extension. To delete your
                    account and all associated data, email us at info@highvocab.com from the address you
                    signed up with, and we will delete it within 30 days. Purchase records may be kept
                    longer where the law requires it.
                  </p>

                  <h5 className="card-title">6. Security</h5>
                  <p className="text-muted">
                    We use encrypted connections (HTTPS) and other reasonable measures to protect your
                    information from unauthorized access, alteration, disclosure or destruction. No method of
                    transmission or storage is completely secure, but we work to protect your data.
                  </p>

                  <h5 className="card-title">7. Children</h5>
                  <p className="text-muted">
                    HighVocab is not directed to children under 13, and we do not knowingly collect personal
                    information from them. If you believe a child has given us personal information, contact
                    us and we will delete it.
                  </p>

                  <h5 className="card-title">8. Changes to this policy</h5>
                  <p className="text-muted">
                    We may update this Privacy Policy from time to time. We will post changes on this page and
                    update the "Last updated" date above. If a change is significant, we will let you know by
                    email or in the product.
                  </p>

                  <h5 className="card-title">9. Contact us</h5>
                  <p className="text-muted mb-0">
                    Questions or requests about your privacy: info@highvocab.com
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default PagePrivacy;
